module.exports = __webpack_public_path__ + "img/android-code.bb68998.png";